"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var claims_1 = require("../utils/claims");
var app_1 = __importDefault(require("../constants/app"));
var useHasClaims = function (claims, withSpecialCases) {
    if (withSpecialCases === void 0) { withSpecialCases = { root: true, admin: true, dtna: true }; }
    var _a = (0, react_1.useState)(false), value = _a[0], setValue = _a[1];
    var readValue = (0, react_1.useCallback)(function () { return (0, claims_1.hasClaim)(claims, withSpecialCases); }, [claims]);
    (0, react_1.useEffect)(function () {
        setValue(readValue());
    }, []);
    var handleClaimsChange = (0, react_1.useCallback)(function () {
        setValue(readValue());
    }, [claims]);
    window.addEventListener(app_1.default.SESSION_STORAGE.GLOBAL_EVENT, handleClaimsChange);
    return value;
};
exports.default = useHasClaims;
